import { ReactElement, useState } from "react";
import { routes } from "../../shared/routes";
import useBreadcrumbs, { BreadcrumbMatch } from "use-react-router-breadcrumbs";
import React from "react";
import { Link, useNavigate } from "react-router";
import "../../styles/style.scss";
import FormDirtyListener from "../formListener/FormDirtyListener";
import { LeaveDialog } from "../form/components/leavePage/LeavePageWarning";
import { eventEmitter } from "../../shared/event";

export interface BreadcrumbData<ParamKey extends string = string> {
  match: BreadcrumbMatch<ParamKey>;
  location: Location;
  key: string;
  breadcrumb: React.ReactNode;
}
const hiddenRoutes = [
  "/applications/ApplicationBaseCurrent",
  "/applications/ApplicationBaseLegacy",
  "/provider/applications/ApplicationBaseCurrent",
  "/provider/applications/ApplicationBaseLegacy",
  "/assessments/ApplicationBaseCurrent",
  "/assessments/ApplicationBaseLegacy",
  "/myapplications/ApplicationBaseCurrent",
  "/myapplications/ApplicationBaseLegacy",
  "/finalised/ApplicationBaseCurrent",
  "/finalised/ApplicationBaseLegacy",
  "/applicationsLegacy/ApplicationBaseLegacy",
  "/assessmentsLegacy/ApplicationBaseLegacy",
  "/myapplicationsLegacy/ApplicationBaseLegacy",
  "/finalisedLegacy/ApplicationBaseLegacy",
];

export default function Breadcrumbs(): ReactElement | null {
  const breadcrumbs = useBreadcrumbs(routes);
  const [showDialog, setShowDialog] = useState(false);
  const [navigatePath, setNavigatePath] = useState("");
  const navigate = useNavigate();
  const [isDirty, setIsDirty] = useState(false);

  const handleBreadcrumbClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, path: string) => {
    if (isDirty) {
      e.preventDefault();
      setNavigatePath(path);
      setShowDialog(true);
      return;
    }
  };

  const handleLeavePage = () => {
    setShowDialog(false);
    eventEmitter.emit("IsDirtyForm", false);
    navigate(navigatePath);
  };

  const handleStay = () => {
    setShowDialog(false);
  };
  return (
    <>
      <FormDirtyListener onDirtyChange={setIsDirty} />
      <nav>
        <ul className="breadcrumb m-0">
          {breadcrumbs
            .filter((x) => !hiddenRoutes.includes(x.key))
            .map(({ match, breadcrumb }) => (
              <li className="breadcrumb-item" key={match.pathname}>
                <Link
                  to={match.pathname}
                  className="breadcrumb-link"
                  onClick={(e) => {
                    handleBreadcrumbClick(e, match.pathname);
                  }}>
                  {breadcrumb}
                </Link>
              </li>
            ))}
        </ul>
      </nav>
      {showDialog && LeaveDialog(showDialog, handleStay, handleLeavePage)}
    </>
  );
}
